import type { FaireProductEntity } from "../../entity_types/product";

export const p_rfghv6cb8p: FaireProductEntity = {
  token: "p_rfghv6cb8p",
  type: "product",
  name: "Lantern LED Lamp with Lustre or Smoked  Chimney",
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/f12793720a9c86f26f94d5c66bb22dbc7c5780f5216bb7c410a7a923cad7d154.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/19036bc72db764a1b5723f2be55f3e974e695de00c7fd039f6b02f714ad9113d.jpeg",
    "https://cdn.faire.com/fastly/9f65bdb3fbb37d333a44ac1cade6aae15a792235ea6c07011efd2869b97be4a5.jpeg",
    "https://cdn.faire.com/fastly/f9c5daf497dbdba4ff3efc4215eff8f287d8d7f7c4d2b0a94561de508719dd70.jpeg",
    "https://cdn.faire.com/fastly/09e672a465ae79654d55c34dc16a6e53f887146cb6c4a43aa59e86e9fa17ca8c.jpeg",
  ],
  priceDollars: 45,
  description:
    "Where nostalgia meets innovation – light up your world in style. Add a touch of timeless elegance to your space with our LED Lantern Lamp, a perfect fusion of classic design and modern technology. Inspired by vintage oil lamps, this USB-rechargeable lantern features a dimmable Edison-style LED bulb, allowing you to set the perfect ambiance with a simple turn of the knob. The glass chimney enhances its sophisticated appeal, while the matte  metal base offers a sturdy, minimalist aesthetic that complements any decor – from rustic and industrial to modern and cozy. Designed for both indoor and outdoor use, this lamp is an effortless way to bring warm, atmospheric lighting to your bedside table, dining space, patio, or reading nook. No messy cords, no open flames - just pure, flickering ambiance at your fingertips.",
  tags: [],
  msrpDollars: 90,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:08.341Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
